import script from "./orderdetails.vue?vue&type=script&setup=true&lang=js"
export * from "./orderdetails.vue?vue&type=script&setup=true&lang=js"

import "./orderdetails.vue?vue&type=style&index=0&id=8c4ce8ce&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c4ce8ce"]])

export default __exports__